module.exports = __webpack_public_path__ + "img/Louve_logo.3f118198.png";